var _defs, _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _ellipse, _path14, _path15, _path16, _rect2, _path17, _g, _g2, _g3, _g4, _path18, _g5, _g6, _g7, _g8, _g9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFridayThe13(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "friday_the_13_svg__Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 840 1040",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".friday_the_13_svg__cls-2{fill:#fa505e}.friday_the_13_svg__cls-3{fill:#024447}.friday_the_13_svg__cls-6{fill:#fd934f}.friday_the_13_svg__cls-7{fill:#cae0e3}.friday_the_13_svg__cls-9{fill:#2a848e}.friday_the_13_svg__cls-10{stroke-width:32px}.friday_the_13_svg__cls-10,.friday_the_13_svg__cls-11,.friday_the_13_svg__cls-12,.friday_the_13_svg__cls-13{fill:none;stroke-linecap:round;stroke-linejoin:round}.friday_the_13_svg__cls-10{stroke:#fff}.friday_the_13_svg__cls-11{stroke:#fa505e}.friday_the_13_svg__cls-11,.friday_the_13_svg__cls-12,.friday_the_13_svg__cls-13{stroke-width:16px}.friday_the_13_svg__cls-12{stroke:#f93444}.friday_the_13_svg__cls-13{stroke:#006c78}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "friday_the_13_svg__cls-6",
    d: "M510.84 891.47h100.12c17.83 0 32.31 14.48 32.31 32.31v21.02c0 6.23-5.06 11.29-11.29 11.29H510.84c-17.83 0-32.31-14.48-32.31-32.31 0-17.83 14.48-32.31 32.31-32.31z",
    transform: "rotate(-161.73 560.931 923.764)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "friday_the_13_svg__cls-11",
    d: "M491.77 867.24l-9.09 30.72c-5.57 16.87 3.68 35.24 20.55 40.81l95.07 31.38c16.87 5.57 35.24-3.68 40.81-20.55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "friday_the_13_svg__cls-9",
    d: "M667.46 478.67v321.65c0 62.9-48.41 114.51-110 119.58-3.29.28-6.63.42-10 .42H329.93c-3.37 0-6.71-.14-10-.42-61.6-5.07-110-56.68-110-119.58V478.67c0-126.34 102.42-228.76 228.76-228.76 63.17 0 120.36 25.6 161.76 67 41.4 41.4 67.01 98.59 67.01 161.76z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "friday_the_13_svg__cls-9",
    d: "M118.76 707.2c73.33 56.02 177.34 43.85 235.92-26.28l-235.8-180.13"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "friday_the_13_svg__cls-9",
    d: "M118.88 500.79c-21.26-16.24-52.1-6.24-59.99 19.33-20.6 66.77 1.1 142.19 59.87 187.09"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "friday_the_13_svg__cls-13",
    d: "M118.88 500.79c-21.26-16.24-52.1-6.24-59.99 19.33-20.6 66.77 1.1 142.19 59.87 187.09"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "friday_the_13_svg__cls-3",
    x: 196.52,
    y: 473.46,
    width: 482.24,
    height: 56.87,
    rx: 8,
    ry: 8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "friday_the_13_svg__cls-9",
    d: "M809.06 696.42c16.67 12.66 15.54 37.99-2.1 49.25-46.07 29.42-107.45 28.74-153.53-6.24-57.49-43.65-69.95-124.61-29.24-183.37l184.87 140.36z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "friday_the_13_svg__cls-13",
    d: "M806.96 745.68c-46.07 29.42-107.45 28.74-153.53-6.24"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M557.46 804.72V652.95c0-65.53-52.53-119.69-118.06-120.07-65.81-.39-119.47 53.03-119.47 118.76v153.08c0 41.75 33.85 75.6 75.6 75.6h86.33c41.75 0 75.6-33.85 75.6-75.6z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "friday_the_13_svg__cls-7",
    d: "M439.4 532.88c-65.81-.39-119.47 53.03-119.47 118.76v57.86c6.86 4.79 13.97 9.17 21.31 13.12v18.09c0 22.08 17.98 40.04 40.07 40.04 8.3 0 16.31-2.58 23.17-7.48l11.74-8.38c4.6 1.51 9.44 2.3 14.32 2.3h16.32c4.88 0 9.72-.79 14.32-2.3l11.74 8.38c6.85 4.89 14.86 7.48 23.16 7.48 10.33 0 20.17-3.94 27.7-11.08 7.98-7.58 12.37-17.86 12.37-28.95v-18.09c7.34-3.95 14.45-8.34 21.31-13.12v-56.55c0-65.53-52.53-119.69-118.06-120.07z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "friday_the_13_svg__cls-9",
    d: "M501.11 182.4c17.34 0 31.42 14.08 31.42 31.42v93.43c0 17.34-14.08 31.42-31.42 31.42h-31.42V213.83c0-17.34 14.08-31.42 31.42-31.42z",
    transform: "rotate(45 501.112 260.537)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "friday_the_13_svg__cls-9",
    d: "M444.59 163.79c17.34 0 31.42 14.08 31.42 31.42v93.43c0 17.34-14.08 31.42-31.42 31.42h-31.42V195.22c0-17.34 14.08-31.42 31.42-31.42z",
    transform: "rotate(45 444.595 241.917)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "friday_the_13_svg__cls-13",
    d: "M455.41 186.67c12.22-12.22 32.21-12.22 44.43 0 12.22 12.22 12.22 32.21 0 44.43l-50.92 50.92"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 438.7,
    cy: 501.9,
    rx: 202.3,
    ry: 225.51,
    fill: "#fff4c9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M640.99 501.9c0-124.55-90.57-225.51-202.3-225.51s-202.3 100.97-202.3 225.51",
    strokeWidth: 16,
    stroke: "#fff",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "friday_the_13_svg__cls-2",
    d: "M392.86 757c-13.24 9.45-31.62-.02-31.62-16.28v-55.35c0-16.26 18.38-25.73 31.62-16.28l20.53 14.65c20.12 14.36 20.12 44.25 0 58.61L392.86 757zM484.53 757c13.24 9.45 31.62-.02 31.62-16.28v-27.67-27.67c0-16.26-18.38-25.73-31.62-16.28L464 683.75c-20.12 14.36-20.12 44.25 0 58.61l20.53 14.65z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "friday_the_13_svg__cls-12",
    d: "M387.06 713.05h103.27"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "friday_the_13_svg__cls-2",
    x: 420.53,
    y: 694.89,
    width: 36.32,
    height: 36.32,
    rx: 10,
    ry: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M446.86 694.89c5.52 0 10 4.48 10 10v16.32c0 5.52-4.48 10-10 10h-16.32c-5.52 0-10-4.48-10-10v-16.32c0-5.52 4.48-10 10-10h16.32m0-16h-16.32c-14.34 0-26 11.66-26 26v16.32c0 14.34 11.66 26 26 26h16.32c14.34 0 26-11.66 26-26v-16.32c0-14.34-11.66-26-26-26z",
    fill: "#f93444"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "friday_the_13_svg__cls-10",
    d: "M402.69 501.9c0 25.21-20.44 45.66-45.66 45.66s-45.66-20.44-45.66-45.66M566.02 501.9c0 25.21-20.44 45.66-45.66 45.66s-45.66-20.44-45.66-45.66"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "friday_the_13_svg__cls-3",
    cx: 357.03,
    cy: 501.9,
    r: 45.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "friday_the_13_svg__cls-3",
    cx: 520.36,
    cy: 501.9,
    r: 45.66
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "friday_the_13_svg__cls-3",
    cx: 395.3,
    cy: 610.31,
    r: 9.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "friday_the_13_svg__cls-3",
    cx: 438.7,
    cy: 610.31,
    r: 9.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "friday_the_13_svg__cls-3",
    cx: 482.09,
    cy: 610.31,
    r: 9.13
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "friday_the_13_svg__cls-3",
    cx: 417,
    cy: 646.21,
    r: 9.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "friday_the_13_svg__cls-3",
    cx: 460.39,
    cy: 646.21,
    r: 9.13
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "friday_the_13_svg__cls-12",
    d: "M396.46 383.84l42.24 57.47 42.23-57.47"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "friday_the_13_svg__cls-3",
    cx: 325.01,
    cy: 409.01,
    r: 9.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "friday_the_13_svg__cls-3",
    cx: 300.07,
    cy: 433.94,
    r: 9.13
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "friday_the_13_svg__cls-3",
    cx: 552.38,
    cy: 409.01,
    r: 9.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "friday_the_13_svg__cls-3",
    cx: 577.32,
    cy: 433.94,
    r: 9.13
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "friday_the_13_svg__cls-6",
    d: "M265.63 887.13h121.14c6.23 0 11.29 5.06 11.29 11.29v21.02c0 17.83-14.48 32.31-32.31 32.31H265.63c-17.83 0-32.31-14.48-32.31-32.31 0-17.83 14.48-32.31 32.31-32.31z",
    transform: "rotate(13.68 315.623 919.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "friday_the_13_svg__cls-11",
    d: "M402.32 907.57l-6.6 31.35c-4.2 17.27-21.76 27.95-39.03 23.75L259.41 939c-17.27-4.2-27.95-21.76-23.75-39.03"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "friday_the_13_svg__cls-7",
    d: "M155.82 466.31l20.83-398.08c-40.27 0-72.92 32.65-72.92 72.92v325.16h52.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#95c2c7",
    d: "M103.73 438.46v27.85h52.09l1.46-27.85h-53.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.65 68.23h0c-40.27 0-72.92 32.65-72.92 72.92v158.63",
    stroke: "#95c2c7",
    strokeWidth: 16,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "friday_the_13_svg__cls-3",
    d: "M99.58 465.29v14.93c0 3.88 2.16 7.45 5.6 9.25l2.8 1.46c3.44 1.8 5.6 5.36 5.6 9.25v47.58c0 4.44-2.81 8.39-7 9.85-4.19 1.46-7 5.41-7 9.85v16.03c0 5.76 4.67 10.43 10.43 10.43H141c6.42 0 11.97-5.25 12.34-11.66L160 465.49a3.63 3.63 0 00-3.63-3.84h-53.15a3.64 3.64 0 00-3.64 3.64z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "friday_the_13_svg__cls-9",
    d: "M95.78 493.13h45.34c10.85 0 19.65 8.8 19.65 19.65 0 10.85-8.8 19.65-19.65 19.65H95.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "friday_the_13_svg__cls-13",
    d: "M95.78 493.13h45.34c10.85 0 19.65 8.8 19.65 19.65 0 10.85-8.8 19.65-19.65 19.65H95.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "friday_the_13_svg__cls-9",
    d: "M95.78 532.43h45.34c10.85 0 19.65 8.8 19.65 19.65 0 10.85-8.8 19.65-19.65 19.65H95.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "friday_the_13_svg__cls-13",
    d: "M95.78 532.43h45.34c10.85 0 19.65 8.8 19.65 19.65 0 10.85-8.8 19.65-19.65 19.65H95.78"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFridayThe13);
export default ForwardRef;